import React from 'react';
import Linkify from 'react-linkify';
import { Link } from './styles';
const hrefDecorator = (decoratedHref, decoratedText, key) => (React.createElement(Link, { key: key, target: "blank", rel: "noopener noreferrer", href: decoratedHref }, decoratedText));
const UiKitLinkify = (props) => React.createElement(Linkify, Object.assign({ componentDecorator: hrefDecorator }, props));
export default UiKitLinkify;
//# sourceMappingURL=index.js.map